import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import propTypes from 'prop-types';

import { visitLogin } from 'app/Router/actions';
import nauth from 'lib/nauth';
import { Link } from 'utils/store/thirdPartyConnectToCanvasStore';

/**
 * authenticate users via nauth
 */
export default class Logout extends Component {
  static propTypes = {
    nauth: propTypes.shape({ getNauthTokenCookie: propTypes.func })
  };

  static defaultProps = {
    nauth
  };

  constructor(props) {
    super(props);

    this.state = {
      hasCookie: true
    };
  }

  componentDidMount() {
    const { nauth } = this.props;

    // check for cookie on an interval and update ui only after it isn't found
    this.interval = setInterval(() => {
      const hasCookie = !!nauth.getNauthTokenCookie();
      if (!hasCookie) {
        this.setState({ hasCookie });
        clearInterval(this.interval);
      }
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { hasCookie } = this.state;
    const color = hasCookie ? 'info' : 'success';
    const msg = hasCookie ? 'logging out...' : 'successfully logged out';
    return (
      <div className="w-100">
        <Alert color={color}>
          <div className="d-flex">
            <span className="mr-auto">{msg}</span>
            {!hasCookie && <Link to={visitLogin({ sso: false })}>login</Link>}
          </div>
        </Alert>
      </div>
    );
  }
}
